'use client';

import React, { useMemo } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { ProjectRecord } from '@/lib/projects/project-types';
import type { SourceRunStatus } from '@/lib/sources/source-types';

interface DashboardKpiStripProps {
  projects: ProjectRecord[];
  sourceStatuses: SourceRunStatus[];
}

export const DashboardKpiStrip = React.memo(function DashboardKpiStrip({
  projects,
  sourceStatuses,
}: DashboardKpiStripProps) {
  const kpis = useMemo(() => {
    const totalProjects = projects.length;
    const orgCount = new Set(projects.map((p) => p.organizationName)).size;
    const sourceCount = sourceStatuses.length;
    const cfpCount = projects.filter((p) => p.callForProposalLink !== null).length;
    return [
      { label: 'Projects indexed', value: totalProjects },
      { label: 'Organisations', value: orgCount },
      { label: 'Sources', value: sourceCount },
      { label: 'CFPs found', value: cfpCount },
    ];
  }, [projects, sourceStatuses]);

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {kpis.map((kpi) => (
        <Card key={kpi.label} size="sm">
          <CardContent className="pt-0">
            <p className="text-2xl font-bold tabular-nums">{kpi.value}</p>
            <p className="text-sm text-muted-foreground">{kpi.label}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
});
